import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';

const popupText = `אם תבחרו להמשיך, כל הסימונים יוסרו מהחשבונות שבחרתם ${!isMobile ? '<br />' : ''} ותצטרכו לסמן מחדש`;

const PopupContent = (props) => {
  const {buttonFunction, closeModal, title, cancelBtnText, btnText, validCC, errorTxt, banToIdOfCCError, isBusiness} = props;
  const txt = errorTxt ? errorTxt : popupText;
  return (
    <Container className={`${isMobile ? 'isMobile' : ''} text-center update-payment-popup`}>
      <Row>
        <p className='bold main-text d-block w-100'>{title}</p>
      </Row>
      <Row>
        <Col>
          <p className={`${isMobile ? 'w-100' : ''}`} dangerouslySetInnerHTML={{__html: txt}} />
        </Col>
      </Row>
      <Row>
        <Col className={`close-modal ${isMobile ? 'pl-0 pr-0 col-12 mb-3' : ''}`}>
          <BtnSubmit isBusiness={isBusiness} text={cancelBtnText} onclick={() => closeModal()} />
        </Col>
        {validCC === false || banToIdOfCCError ? null : (
          <Col className={`${isMobile ? 'pl-0 pr-0 col-12' : ''}`}>
            <BtnSubmit isBusiness={isBusiness} text={btnText} onclick={() => buttonFunction()} />
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default PopupContent;
